import React from 'react';
import { Link } from 'react-router-dom';
import Programmesleft from './ProgrammesleftEle'
import { Container, Row, Col,Table } from 'react-bootstrap';



function MtechEle() {
  return (
    <section className="project-detail">
      <Container>
        <Row>
          <Col md={4} className='c-left custom-padding-color mb-4'>
            <Programmesleft activeIndex={1}/>
          </Col>

          <Col md={8} className='c-right'>
           
           
            <div className="c-heading">
              <h3>M.Tech.</h3>
              </div>
            <p>
              IIT Tirupati offers M.Tech. program(s) in the following Departments:
            </p>

            <ul className='myulcustarrow'>
            <li>
              The Department of Mechanical Engineering has started a post graduate program M.Tech. in Computational Mechanics from the Academic Year 2026-27.
              </li>
              <li>
                	The Department of Computer Science and Engineering offers a post graduate program M.Tech. in Data Science & Artificial Intelligence from the Academic Year 2025-26.
              </li>
              
              
            </ul>


            <Table bordered responsive className='mt-3'>
              <thead>
                <tr>
                  <th>Department</th>
                  <th>Intake</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical Engineering</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td>Civil and Environmental Engineering</td>
                  <td>48</td>
                </tr>
                <tr>
                  <td>Computer Science and Engineering</td>
                  <td>35</td>
                </tr>
                <tr>
                  <td>Electrical Engineering</td>
                  <td>42</td>
                </tr>
                <tr>
                  <td>Mechanical Engineering</td>
                  <td>45</td>
                </tr>
              </tbody>
            </Table>
     
    
              For more information{' '}
              <b>
              <Link to="/m-tech-admission" target="_blank" rel="noopener noreferrer" className='c-link'>
                  click here
                </Link>
              </b>
          </Col>
        </Row>
      </Container>

    </section>
  );
}

export default MtechEle;
